module.exports = __webpack_public_path__ + "static/media/2013 - 14 Andy Lui-min.59b9a804.jpg";